import React, { Component } from 'react';
import axios from 'axios';
import { HeaderTD, TD1, TD2 } from './LayoutComponents';

export class Participant extends Component {

  constructor(props) {
    super(props);

    this.state = {
      participantData: []
    }

    this.getParticipantData();
  }

  async getParticipantData() {
    var response = axios.get('/getparticipantdata', { params: { pFastType: this.props.match.params.id } });
    try {
      var resultData = (await response).data;
      this.setState({ participantData: resultData });
    } 
    catch {
      this.setState({ participantData: [] });
    }
  }

  getDayIndex(dayNum) {
    switch(dayNum) {
      case "1":
        return "일요일";
      case "2":
        return "월요일";
      case "3":
        return "화요일";
      case "4":
        return "수요일";
      case "5":
        return "목요일";
      case "6":
        return "금요일";
      case "7":
        return "토요일";
      default:
        return "";
    }
  }

  getMealIndex(mealNum) {
    switch(mealNum) {
      case "1":
        return "아침";
      case "2":
        return "점심";
      case "3":
        return "저녁";
      default:
        return "";
    }
  }

  render() {
    const fastType = this.props.match.params.id.toString();
    var titleStr = "";
    if(fastType.length === 1) {
      titleStr = "(" + this.getDayIndex(fastType) + " 하루 금식)"
    }
    else {
      titleStr = "(" + this.getDayIndex(fastType[0]) + " " + this.getMealIndex(fastType[1]) + " 금식)";
    }

    return (
      <div>
        <h2>금식 기도 참가자 명단 - {titleStr}</h2>
        <br/>
        <div style={{width: '100%', textAlign: 'center'}}>
        <table align="center" width="600px" style={{textAlign: 'center'}}><tbody>
          <tr>
            <HeaderTD width="40px">#</HeaderTD>
            <HeaderTD width="160px">ID</HeaderTD>
            <HeaderTD width="200px">이름</HeaderTD>
            <HeaderTD width="200px">직분</HeaderTD>
          </tr>
          {this.state.participantData.map(prt => (
            <tr key={prt.number}>
              {parseInt(prt.number) % 2 === 1 ? (<>
                <TD1>{prt.number}</TD1>
                <TD1>{prt.id}</TD1>
                <TD1>{prt.name}</TD1>
                <TD1>{prt.title}</TD1>
              </>): (<>
                <TD2>{prt.number}</TD2>
                <TD2>{prt.id}</TD2>
                <TD2>{prt.name}</TD2>
                <TD2>{prt.title}</TD2>
              </>)}
            </tr>
          ))} 
        </tbody></table>
        <br />
        <br />
        <table align="center"><tbody><tr>
          <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.props.history.push("/chart")}>참가자</button></td>
          <td width="10px" />
          <td style={{textAlign: 'center'}}><button className="btn btn-primary" onClick={() => this.props.history.push("/signup")}>금식 기도 참여</button></td>
        </tr></tbody></table>
        </div>
      </div>
    );
  }
}
